import * as React from 'react';
import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { ResidenceCardData } from 'features/search/types';
import { StageStatus } from 'features/search/filters/enums';
import { ModalPosition, useModal } from 'features/modal/hooks/useModal';
import { gtmEventsInterestSignupOpen } from 'features/services/googleTagManager/events';
import { getFormattedMessage } from 'features/services/utils/language-helper';

import { Button, ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';
import { InterestFormModal } from 'components/modals/General/InterestFormModal';

interface Props {
    residence: ResidenceCardData;
}

export const ResidenceInterestButton: React.FunctionComponent<Props> = ({residence}) => {
    const stageInterestBtnRef = useRef<HTMLButtonElement>(null);
    const { open } = useModal();
    
    const onInterestClick = () => {
        gtmEventsInterestSignupOpen("default")();

        open(
            <InterestFormModal
                stageName={residence.name}
                stageId={residence.id}
                stageStatus={residence.stageStatus}
                interestType="default"
                hideMessageField={residence.stageStatus === StageStatus.PLANNED || residence.stageStatus === StageStatus.VIP}
                basicSignupPulText="PUL text" //{residence.basicSignupPulText}
                labelPrefix="modal-"
            />,
            { fullscreen: false, position: ModalPosition.RIGHT, triggerElementId: 'residenceCardInterestStage-' + residence.id, ariaLabel: getFormattedMessage('jm.components.InterestForm.header') }
        );
    };
    
    return (
        <Button
            className='residence-block__interest-button'
            onClick={onInterestClick}
            preventDefault
            ref={stageInterestBtnRef}
            id={'residenceCardInterestStage-' + residence.id}
            buttonColor={ButtonColor.LIGHT} 
            buttonSize={ButtonSize.SMALL} 
            buttonType={ButtonType.DEFAULT} 
        >
            <FormattedMessage id='jm.components.StagePage.buttonTextInterest' />
        </Button>
    );
};